module.exports = __webpack_public_path__ + "img/buddy_body.14921c83.svg";